import { createApp } from 'vue';  // استيراد createApp من Vue 3
import App from './App.vue';
import router from './router';

// إنشاء التطبيق
const app = createApp(App);

// إضافة الراوتر إلى التطبيق
app.use(router);

// ربط التطبيق بالـ DOM
app.mount('#app');
